import React from "react";
import { Navigate } from "react-router-dom";
import useAuth from "../Personal Attendance/useAuth";

// ---------------------------------------------------------------------------
// src/pages/KPI/XRayRouteGuard.js
//
// Route guard for the X-Ray finance report. PURE PERMISSION model: access
// requires a KPI finance permission ("KPI - Finance Reports" or
// "KPI - X-Ray Report"). Only IT Admin bypasses (unconditional super-user).
// Role/identity flags (President, Finance) no longer grant access on their
// own — if the KPI permission isn't granted, the report isn't visible. The
// backend API remains [Authorize]d as the real enforcement.
// ---------------------------------------------------------------------------

const XRayRouteGuard = ({ children }) => {
    const auth = useAuth();

    const allowed =
        auth.isItAdmin ||
        (typeof auth.hasAccess === "function" &&
            (auth.hasAccess("KPI - Finance Reports") ||
                auth.hasAccess("KPI - X-Ray Report")));

    if (!allowed) return <Navigate to="/access-denied" replace />;
    return <>{children}</>;
};

export default XRayRouteGuard;
